module.exports = __webpack_public_path__ + "static/media/2.22_preview.09dc9bc7.png";